import {Mapper} from '@s-ui/domain'

export class FromMakesJsonToMakesListVOVehiclesMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.subscriptionModelsListValueObjectFactory
   * */
  constructor({config, makeEntityFactory, makesListValueObjectFactory}) {
    super()
    this._config = config
    this._makeEntityFactory = makeEntityFactory
    this._makesListValueObjectFactory = makesListValueObjectFactory
  }

  map = ({makes = []}) => {
    const makesList = makes.map(make => {
      const {id, name, slug} = make

      return this._makeEntityFactory({id, name, slug})
    })
    return this._makesListValueObjectFactory({items: makesList})
  }
}
